(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/models/match.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/models/match.js'); (function(Backbone, _, svs) {
  'use strict';

  svs.tipset.models.Match = Backbone.Model.extend({
    defaults: {
      isCurrentMatch: false,
      baseRow: [],
      weights: [0, 0, 0]
    },

    initialize: function() {
      this.set('isEnabled', svs.tipset.collections.draws.isCurrentDrawOpen());
      this.listenTo(svs.tipset.models.systems, 'change', this.setSystem);
      this.setGameAnalyzes();
      this.listenTo(
        svs.tipset.models.statistics,
        'changeFromStorage statisticsSet',
        this.setStatistics
      );

      if (svs.core.detect.feature('ft-spelanalyser')) {
        this.listenTo(svs.tipset.collections.draws, 'change:isCurrentDraw', function() {
          if (svs.tipset.collections.draws.getCurrentDraw()) {
            svs.tipset.models.statistics.fetchGameAnalyzes();
          }
        });
      }
      this.listenTo(svs.tipset.models.statistics, 'change:gameAnalyzes change:storedGameAnalyzes change:allStatsUpdated change:analyzesByEvent', this.setGameAnalyzes);
      this.clearAll();
      this.setSystem(this.get('system'));
      this.setIsTvEnabled();
    },

    setIsTvEnabled: function(hasSystem) {
      var showTvIcon = !svs.core.detect.formfactor.mobile()
        ? this.get('match') && this.get('match').media
        : this.get('match') && this.get('match').media && !hasSystem;
      this.set('showTvIcon', showTvIcon, { silent: true });
    },

    clearAll: function(options) {
      this.clearBetButtons(options);

      this.set('weights', [0, 0, 0]);
    },

    clearBetButtons: function(options) {
      var marks = {
        home: {
          cssClass: '',
          isSet: false,
          isU: false,
          boardData: 1,
          isUEnabled: false
        },
        away: {
          cssClass: '',
          isSet: false,
          isU: false,
          boardData: 4,
          isUEnabled: false
        },
        draw: {
          cssClass: '',
          isSet: false,
          isU: false,
          boardData: 2,
          isUEnabled: false
        },
        mg: { cssClass: '', isSet: false, isDisabled: true, boardData: 8 }
      };
      marks.home.isSetByUser =
        options && options.isXpertWithBaseRow
          ? this.get('marks').home.isSetByUser
          : false;
      marks.away.isSetByUser =
        options && options.isXpertWithBaseRow
          ? this.get('marks').away.isSetByUser
          : false;
      marks.draw.isSetByUser =
        options && options.isXpertWithBaseRow
          ? this.get('marks').draw.isSetByUser
          : false;
      this.set('marks', marks);
    },

    setMGDisabled: function() {
      var nrOfMarksNeeded = this.get('marks').mg.isSet ? 2 : 1, 
        isDisabled =
          _.where(this.get('marks'), { isSet: true }).length <= nrOfMarksNeeded,
        mgButton = this.get('marks').mg;

      mgButton.isDisabled = isDisabled;

      if (isDisabled && mgButton.isSet) {
        mgButton.isSet = false;
      }
    },

    setMg: function() {
      this.get('marks').mg.isSet = !this.get('marks').mg.isSet;
      this.setIsTvEnabled();
      this.resetAllUMarks();
      this.trigger('buttonBet', this);
    },

    getIsHalfHedge: function() {
      var nrOfBetMarks = this.getNrOfBetMarks(),
        isHalfHedge = false;

      if (nrOfBetMarks == 2) {
        isHalfHedge = !this.hasMG();
      }

      return isHalfHedge;
    },

    getIsFullHedge: function() {
      var nrOfBetMarks = this.getNrOfBetMarks(),
        isFullHedge = false;

      if (nrOfBetMarks == 3) {
        isFullHedge = !this.hasMG();
      }

      return isFullHedge;
    },

    getIsU: function() {
      return _.where(this.get('marks'), { isU: true }).length > 0;
    },

    hasMarks: function() {
      return _.where(this.get('marks'), { isSet: true }).length > 0;
    },

    hasMG: function() {
      return this.get('marks').mg.isSet;
    },

    setSystem: function() {
      var system = svs.tipset.models.systems.getCurrentSystem();

      if (!system) {
        this.get('marks').mg.isSet = false;
        this.resetAllUMarks();
      }

      if (system && system.type == svs.tipset.constants.SYSTEM_TYPE.R_SYSTEM) {
        this.resetAllUMarks();
      }
      this.setIsTvEnabled(system);
      this.set('system', system);
    },

    setStatistics: function() {
      var statistics = svs.tipset.models.statistics.getStatistics();
      if (statistics.latest && !this.get('isPlayer')) {
        this.setAwayTeamStats();
        this.setHomeTeamStats();
      }

      if (svs.core.detect.feature('ft-spelanalyser')) {
        var hasAnyGameAnalyzes = false;
        if (statistics.storedGameAnalyzes) {
          var keys = Object.keys(statistics.storedGameAnalyzes);
          for (var i = 0; i < keys.length; ++i) {
            if (statistics.storedGameAnalyzes[keys[i]]) {
              hasAnyGameAnalyzes = true;
              break;
            }
          }
        }

        if (hasAnyGameAnalyzes) {
          svs.tipset.models.statistics.fetchGameAnalyzes();
        }
      }

      this.set('statistics', statistics, { silent: true });
      this.trigger('changeStatistics'); 
      svs.events.publish('/loader/hide');
    },

    setGameAnalyzes: function() {
      if (svs.core.detect.feature('ft-spelanalyser')) {
        var gameAnalyzes = svs.tipset.models.statistics.get('analyzesByEvent');
        var storedGameAnalyzes = svs.tipset.models.statistics.get('storedGameAnalyzes');
        if (gameAnalyzes && storedGameAnalyzes) {
          gameAnalyzes = Object.keys(gameAnalyzes).reduce(function(acc, eventNumber) {
            acc[eventNumber] = gameAnalyzes[eventNumber].filter(function(eventAnalysis) {
              var authorId = eventAnalysis.authorProfile.id;
              return storedGameAnalyzes[authorId];
            });
            return acc;
          }, {});

          this.set('analyzesByEvent', gameAnalyzes, { silent: true });
          this.trigger('changeStatistics');
        }
      }
    },

    getNrOfBetMarks: function() {
      var isMG = this.get('marks').mg.isSet,
        doNotCountMg = isMG ? 2 : 0, 
        nrOfMarks = _.where(this.get('marks'), { isSet: true }).length;

      nrOfMarks = nrOfMarks - doNotCountMg;

      return nrOfMarks;
    },

    getBoardData: function() {
      var boardData = 0,
        marks = this.get('marks');

      _.each(marks, function(mark) {
        if (mark.isSet) {
          boardData += mark.boardData;
        }
      });

      return boardData;
    },

    getWeights: function() {
      return this.get('weights');
    },

    setMarks: function(data) {
      var boardData = this.convertFromItsData(data),
        self = this;

      _.each(boardData, function(data) {
        self.setButtonBet(data, { isXpert: true });
      });
    },

    getIsUsystemEnabled: function() {
      return (this.getIsHalfHedge() || this.getIsFullHedge()) && !this.hasMG();
    },

    resetAllUMarks: function() {
      _.each(this.get('marks'), function(mark) {
        mark.isU = false;
      });
    },

    isButtonSet: function(betButtonType) {
      var currentBetButton = _.findWhere(this.get('marks'), {
        boardData: betButtonType
      });
      return currentBetButton.isSet;
    },

    setButtonBet: function(betButtonType, options) {
      var isUsystem =
          this.get('system') &&
          this.get('system').type == svs.tipset.constants.SYSTEM_TYPE.U_SYSTEM,
        currentBetButton = _.findWhere(this.get('marks'), {
          boardData: betButtonType
        }),
        isXpert = options && options.isXpert;

      if (isUsystem && this.getIsUsystemEnabled()) {
        if (currentBetButton.isSet && currentBetButton.isU) {
          currentBetButton.isU = false;
          currentBetButton.isSet = false;
        } else if (currentBetButton.isSet && !currentBetButton.isU) {
          currentBetButton.isU = true;
          _.each(this.get('marks'), function(mark) {
            if (mark.boardData != currentBetButton.boardData) {
              mark.isU = false;
            }
          });
        } else {
          currentBetButton.isSet = !currentBetButton.isSet;
        }
      } else {
        currentBetButton.isSet = !currentBetButton.isSet;
        if (isXpert) {
          currentBetButton.isSetByUser = currentBetButton.isSetByUser
            ? currentBetButton.isSetByUser
            : false;
        } else {
          currentBetButton.isSetByUser = currentBetButton.isSet;
        }
      }

      this.setMGDisabled();
      this.setWeights();
      this.trigger('buttonBet', this);

      if (isXpert || this.shouldShowReduceArrows()) {
        this.trigger('change', this);
      }
    },

    shouldShowReduceArrows: function() {
      if (svs.tipset.models.play.get('isReduceMode')) {
        return (
          this.get('weights') &&
          this.get('weights').filter(function(weight) {
            return weight !== 0;
          }).length > 0
        );
      }
      return false;
    },

    getUBoardData: function() {
      var boardData = 0,
        marks = this.get('marks');

      _.each(marks, function(mark) {
        if (mark.isSet && mark.isU) {
          boardData += mark.boardData;
        }
      });

      return boardData;
    },

    setUMarkFromLocalStorage: function(betButtonType) {
      _.each(this.get('marks'), function(currentButton) {
        if (currentButton.boardData == betButtonType) {
          currentButton.isU = true;
        } else {
          currentButton.isU = false;
        }
      });
    },

    setMarkFromLocalStorage: function(data, baseRow) {
      var betData = this.convertFromItsData(data),
        baseRowData = baseRow ? this.convertFromItsData(baseRow) : undefined;

      _.each(this.get('marks'), function(mark) {
        if (_.contains(betData, mark.boardData)) {
          mark.isSet = true;
        } else {
          mark.isSet = false;
        }

        if (_.contains(baseRowData, mark.boardData)) {
          mark.isSetByUser = true;
        } else {
          mark.isSetByUser = false;
        }
      });
      this.setMGDisabled();
      this.trigger('change buttonBet', this);
    },

    setWeightFromLocalStorage: function(data) {
      this.set('weights', data);
    },

    convertFromItsData: function(boardData) {
      var signArr = [
          { itsId: '1', wagerId: 1 },
          { itsId: '2', wagerId: 4 },
          { itsId: 'X', wagerId: 2 },
          { itsId: 'M', wagerId: 8 },
          { itsId: '0', wagerId: 0 }
        ],
        tmpArr = [];

      for (var i = 0; i < boardData.length; i++) {
        tmpArr[i] = _.findWhere(signArr, { itsId: boardData[i] }).wagerId;
      }
      return tmpArr;
    },

    setCurrentMatch: function(showMatchView) {
      var toggleMatchView = !(
        svs.core.detect.formfactor.mobile() &&
        (svs.tipset.models.uSystemLayer &&
          svs.tipset.models.uSystemLayer.isOpen())
      );

      if (toggleMatchView) {
        var options = {
          eventNumber: this.get('eventNumber'),
          matchLink: this.get('matchLink'),
          showMatchView: showMatchView
        };
        this.set('isCurrentMatch', true);
        this.trigger('currentMatchChanged', options);
      }
    },

    getMarksByUser: function() {
      var boardData = 0,
        marks = this.get('marks');

      _.each(marks, function(mark) {
        if (mark.isSetByUser) {
          boardData += mark.boardData;
        }
      });

      return boardData;
    },
    hasMarksByUser: function() {
      return _.where(this.get('marks'), { isSetByUser: true }).length > 0;
    },

    removeXpertMarks: function() {
      _.each(this.get('marks'), function(mark) {
        if (!mark.isSetByUser) {
          mark.isSet = false;
        }
      });
      this.trigger('change', this);
    },

    setHomeTeamStats: function() {
      var latstMatchesItem = svs.tipset.collections.lastMatches.getLastMatchesByTeamId(
          this.get('match').participants[0].id
        ),
        homeTeam = this.get('match').participants[0];
      homeTeam.latest = latstMatchesItem.get('lastMatches');
      homeTeam.goalAvg = latstMatchesItem.get('goalAverage');
      homeTeam.trend = latstMatchesItem.get('trend');
    },

    setAwayTeamStats: function() {
      var latstMatchesItem = svs.tipset.collections.lastMatches.getLastMatchesByTeamId(
          this.get('match').participants[1].id
        ),
        awayTeam = this.get('match').participants[1];
      awayTeam.latest = latstMatchesItem.get('lastMatches');
      awayTeam.goalAvg = latstMatchesItem.get('goalAverage');
      awayTeam.trend = latstMatchesItem.get('trend');
    },

    hasTeamId: function(teamId) {
      return (
        this.get('match').participants[1].id == teamId ||
        this.get('match').participants[0].id == teamId
      );
    },

    isHomeTeam: function(teamId) {
      return this.get('match').participants[0].id === teamId;
    },

    shouldInsetReduceHandles: function() {
      var weights = this.get('weights');
      return weights[0] > 0 && weights[1] === 0 && weights[2] > 0;
    },

    shouldShowLeftReduceHandle: function() {
      var weights = this.get('weights');
      if (
        (weights[0] > 0 && weights[1] > 0) ||
        (weights[0] > 0 && weights[2] > 0)
      ) {
        return true;
      }
      return false;
    },

    shouldShowRightReduceHandle: function() {
      var weights = this.get('weights');
      if (
        (weights[1] > 0 && weights[2] > 0) ||
        (weights[0] > 0 && weights[2] > 0)
      ) {
        return true;
      }
      return false;
    },

    updateWeights: function(homeWidth, drawWidth, awayWidth) {
      var weights = this.getWeightsFromWidths(homeWidth, drawWidth, awayWidth);

      this.set('weights', weights, { silent: true });
      svs.tipset.objects.localstorageHandler.saveDataToLocalStorage();
      this.trigger('updateWeights', this);
    },

    getWeightsFromWidths: function(homeWidth, drawWidth, awayWidth) {
      var isHomeSet = this.isButtonSet(1),
        isDrawSet = this.isButtonSet(2),
        isAwaySet = this.isButtonSet(4),
        totalWidth = 0;

      totalWidth += isHomeSet ? homeWidth : 0;
      totalWidth += isDrawSet ? drawWidth : 0;
      totalWidth += isAwaySet ? awayWidth : 0;

      var newWeights = [];

      newWeights[0] = (homeWidth / totalWidth) * 100;
      newWeights[1] = (drawWidth / totalWidth) * 100;
      newWeights[2] = (awayWidth / totalWidth) * 100;

      return newWeights;
    },

    setWeights: function() {
      var weights = [0, 0, 0],
        i,
        marks = 0;

      if (this.isButtonSet(1)) {
        weights[0] = 1;
      }

      if (this.isButtonSet(2)) {
        weights[1] = 1;
      }

      if (this.isButtonSet(4)) {
        weights[2] = 1;
      }

      for (i = 0; i < weights.length; ++i) {
        if (weights[i] > 0) {
          marks += 1;
        }
      }

      for (i = 0; i < weights.length; ++i) {
        if (marks === 0) {
          weights[i] = 0;
        } else if (weights[i] > 0) {
          weights[i] = 100 / marks;
        }
      }

      this.set('weights', weights, { silent: true });
      svs.tipset.objects.localstorageHandler.saveDataToLocalStorage();
    }
  });
})(Backbone, _, svs);

 })(window);